import PropTypes from "prop-types";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { getIconByName } from "@utils/client/get-icon-by-name";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faPlus } from "@fortawesome/pro-solid-svg-icons";

export const CollectionSelect = ({ value, onChange, collections }) => {
  const { t } = useTranslation();
  return (
    <FormControl fullWidth size="small">
      <InputLabel>{t("favourites.collection")}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={t("favourites.collection")}
      >
        {collections.length > 0 &&
          collections.map((collection) => (
            <MenuItem key={collection.id} value={collection.id}>
              <Stack direction="row" spacing={1} sx={{
                alignItems: "center"
              }}>
                <SvgIcon fontSize="small" sx={{ color: "action.active" }}>
                  <FontAwesomeIcon
                    icon={getIconByName(collection.icon) || faStar}
                  />
                </SvgIcon>
                <Typography variant="body2">{collection.name}</Typography>
              </Stack>
            </MenuItem>
          ))}
        <Divider />
        <MenuItem value="create-new">
          <Stack direction="row" spacing={1} sx={{
            alignItems: "center"
          }}>
            <SvgIcon fontSize="small" sx={{ color: "primary.main" }}>
              <FontAwesomeIcon icon={faPlus} />
            </SvgIcon>
            <Typography variant="body2" sx={{ color: "primary.main" }}>
              {t("favourites.createNewCollection")}
            </Typography>
          </Stack>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

CollectionSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  collections: PropTypes.array.isRequired,
};
